import { Gate, IGate } from './gate.model';

export interface ICamera {
  cameraId: string;
  neighborhoodId: string;
  gateId?: string;
  description: string;
  hostIp: string;
  hostPort: number;
  ip: string;
  username: string;
  password: string;
  params: string;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  gate?: IGate;
}

export class Camera {
  cameraId: string;
  neighborhoodId: string;
  gateId?: string;
  description: string;
  hostIp: string;
  hostPort: number;
  ip: string;
  username: string;
  password: string;
  params: string;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: Date;
  updatedAt: Date;
  gate?: Gate;

  constructor(data: ICamera) {
    this.cameraId = data.cameraId;
    this.neighborhoodId = data.neighborhoodId;
    this.gateId = data.gateId;
    this.description = data.description;
    this.hostIp = data.hostIp;
    this.hostPort = data.hostPort;
    this.ip = data.ip;
    this.username = data.username;
    this.password = data.password;
    this.params = data.params;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.gate = data.gate ? new Gate(data.gate) : undefined;
  }
}
